import React from 'react';
import Grid from '../Grid';
import Slider from 'react-slick';
import { Section01_Styled, Title, Scheme, HighLightText } from './styled';

class Section01 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null
    };
  }

  componentDidMount() {
    this.setState({
      slickNav: this.slider1,
      slickCarousel: this.slider2
    });
  }

  render() {
    const settingsSlickNav = {
      slidesToShow: 3,
      slidesToScroll: 0,
      dots: false,
      arrows: false,
      focusOnSelect: true,
      className: 'slick-nav',
      asNavFor: this.state.slickCarousel
    };

    const settingsSlick = {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 9000,
      arrows: false,
      dots: false,
      fade: true,
      className: 'slick-main',
      asNavFor: this.state.slickNav,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            dots: true
          }
        }
      ]
    };

    return (
      <Section01_Styled>
        <Grid>
          <Title>
            <h2>how it works?</h2>
            <h1>
              {' '}
              Trusted Interactions for Internal/External<br />APIs and Applications{' '}
            </h1>
          </Title>
          <HighLightText>
            Enable secure access to your API from other internal or external non-interactive third
            party-apps with minimal configuration.
          </HighLightText>
        </Grid>

        <Scheme className="slider-wrapper">
          <Slider ref={slider => (this.slider1 = slider)} {...settingsSlickNav}>
            <div>
              The application authenticates itself with Auth0 using its Client Id and Client Secret.
            </div>
            <div>Auth0 validates this information and returns an Access Token.</div>
            <div>The application can use the Access Token to call the API</div>
          </Slider>
          <Slider ref={slider => (this.slider2 = slider)} {...settingsSlick}>
            <div>
              <video
                muted={'true'}
                autoPlay={'true'}
                loop={'true'}
                src="https://videos.ctfassets.net/uv3ln4emu9ke/2XEPHAow2A0ucG08eOeSSq/13fc4d723938fc69a8f3f73810f63622/scheme-animation.mp4"
              />
              <img src="https://cdn.auth0.com/website/machine-to-machine/images/scheme/mobile-scheme-01.png" />
            </div>
            <div>
              <video
                muted={'true'}
                autoPlay={'true'}
                loop={'true'}
                src="https://videos.ctfassets.net/uv3ln4emu9ke/2YONIFsRRC4cK0maCyiUGO/4c1abbaa5ec90f7a3fb53808a5f93ecf/scheme-animation-02.mp4"
              />
              <img src="https://cdn.auth0.com/website/machine-to-machine/images/scheme/mobile-scheme-02.png" />
            </div>
            <div>
              <video
                muted={'true'}
                autoPlay={'true'}
                loop={'true'}
                src="https://videos.ctfassets.net/uv3ln4emu9ke/2JF0VyvIGQE4KC4ssmOacA/de6f8e6ca2a3ecd009e1e69fabd7ff4e/scheme-animation-03.mp4"
              />
              <img src="https://cdn.auth0.com/website/machine-to-machine/images/scheme/mobile-scheme-03.png" />
            </div>
          </Slider>
        </Scheme>
      </Section01_Styled>
    );
  }
}

export default Section01;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-01/Section-01.js